import classNames from 'classnames';
import React from 'react';

import { Box, Grid, Link, Typography } from '@material-ui/core';

import { IconArrowDown } from '../components/icon';
import { makeBlockStyles, useBlockStyles } from '../hooks/useStyles';
import { BlockBuilder, BlockFaq } from '../types/_blocks.types';

const useStyles = makeBlockStyles(() => ({
  root: {
    paddingBottom: '4rem',
  },
  faqLinks: {
    color: '#000000',
    '& h3, & h4, & h5': {
      display: 'inline',
    },
  },
}));

type Props = BlockBuilder<BlockFaq>;

export const FaqBlock: React.FC<Props> = ({ block }) => {
  const classes = useBlockStyles(useStyles, block);
  const items = block.items.filter((i) => !!i.title); // strip empty faq items

  return (
    <Box className={classNames(classes.boxBlock, classes.root)}>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={9}>
          {/* FAQ Headers */}
          <Grid container justifyContent="center">
            {items.map((item, idx) => {
              const isLastOddItem =
                idx + 1 === items.length && (idx + 1) % 2 !== 0;
              return (
                <Grid
                  item
                  key={item.id}
                  xs={12}
                  sm={isLastOddItem ? 12 : 6}
                  lg={isLastOddItem ? 10 : 5}
                >
                  <Link className={classes.faqLinks} href={`#${item.id}`}>
                    <Typography variant="h6">
                      <IconArrowDown fontSize="small" />
                      &nbsp;
                      <span
                        style={{ fontSize: '80%' }}
                        dangerouslySetInnerHTML={{ __html: item.title }}
                      />
                    </Typography>
                  </Link>
                </Grid>
              );
            })}
          </Grid>
          {/* FAQ Content */}
          <Grid
            container
            justifyContent="center"
            spacing={4}
            style={{ marginTop: '2rem' }}
          >
            {items.map((item) => (
              <Grid item id={item.id} key={item.id} xs={12} lg={10}>
                <Box dangerouslySetInnerHTML={{ __html: item.title }} />
                <Box dangerouslySetInnerHTML={{ __html: item.content }} />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
